const CardSkeleton = () => (
  <div className="px-3 mb-3">
    <div
      className="business-card skeleton-card"
      style={{
        height: "490px",
        borderRadius: "12px",
        padding: "20px",
        backgroundColor: "#ffffff",
        border: "1px solid rgba(34, 34, 34, 0.05)",
        boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div>
        {/* Avatar and Title */}
        <div className="d-flex align-items-center gap-2 mb-3">
          <div
            className="skeleton-animate"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: "#e0e0e0",
            }}
          ></div>
          <div style={{ flexGrow: 1 }}>
            <div
              className="skeleton-animate mb-2"
              style={{
                width: "60%",
                height: "16px",
                borderRadius: "4px",
                backgroundColor: "#e0e0e0",
              }}
            ></div>
            <div
              className="skeleton-animate"
              style={{
                width: "35%",
                height: "12px",
                borderRadius: "4px",
                backgroundColor: "#e0e0e0",
              }}
            ></div>
          </div>
        </div>

        {/* Badges */}
        <div className="d-flex gap-2 mb-3">
          <div
            className="skeleton-animate"
            style={{
              width: "70px",
              height: "24px",
              borderRadius: "12px",
              backgroundColor: "#e0e0e0",
            }}
          ></div>
          <div
            className="skeleton-animate"
            style={{
              width: "60px",
              height: "24px",
              borderRadius: "12px",
              backgroundColor: "#e0e0e0",
            }}
          ></div>
        </div>

        {/* Metadata lines */}
        <div className="mb-3">
          {[...Array(3)].map((_, i) => (
            <div className="d-flex justify-content-between mb-2" key={i}>
              <div
                className="skeleton-animate"
                style={{
                  width: "30%",
                  height: "12px",
                  borderRadius: "4px",
                  backgroundColor: "#e0e0e0",
                }}
              ></div>
              <div
                className="skeleton-animate"
                style={{
                  width: "50%",
                  height: "12px",
                  borderRadius: "4px",
                  backgroundColor: "#e0e0e0",
                }}
              ></div>
            </div>
          ))}
        </div>

        {/* Info grid row */}
        <div className="d-flex justify-content-between mb-3 pt-2 border-top">
          {[...Array(3)].map((_, i) => (
            <div key={i} style={{ width: "30%" }}>
              <div
                className="skeleton-animate mb-1"
                style={{
                  width: "50%",
                  height: "10px",
                  borderRadius: "3px",
                  backgroundColor: "#e0e0e0",
                }}
              ></div>
              <div
                className="skeleton-animate"
                style={{
                  width: "80%",
                  height: "12px",
                  borderRadius: "4px",
                  backgroundColor: "#e0e0e0",
                }}
              ></div>
            </div>
          ))}
        </div>

        {/* Description line */}
        <div className="mb-3">
          <div
            className="skeleton-animate mb-2"
            style={{
              width: "90%",
              height: "12px",
              borderRadius: "4px",
              backgroundColor: "#e0e0e0",
            }}
          ></div>
          <div
            className="skeleton-animate"
            style={{
              width: "70%",
              height: "12px",
              borderRadius: "4px",
              backgroundColor: "#e0e0e0",
            }}
          ></div>
        </div>

        {/* Products placeholder */}
        <div
          className="skeleton-animate mb-3"
          style={{
            width: "100%",
            height: "56px",
            borderRadius: "6px",
            backgroundColor: "#e0e0e0",
          }}
        ></div>
      </div>

      {/* Button placeholder at bottom */}
      <div
        className="skeleton-animate mt-auto"
        style={{
          width: "100%",
          height: "38px",
          borderRadius: "8px",
          backgroundColor: "#e0e0e0",
        }}
      ></div>
    </div>
  </div>
);

export default CardSkeleton;
